import React from "react";
import CustomCard from "../../../components/Common/CustomCard";
import config from "../../../config";
import CompletedIcon from "../../../assets/images/lystfacelogos/CompletedIcon.svg"
import { useSelector } from "react-redux";
import PendingIcon from "../../../assets/images/lystfacelogos/PendingIcon.svg"
import { Link, useNavigate } from "react-router-dom";


const APIDocumentsDescription = () => {
    const ConstDetailsProp = useSelector(state => state.Login.constDetails)
    const { card_setup } = ConstDetailsProp
    const AppListState = useSelector(state => state.Home?.appsListDetails)
    const { appListCount, responseCode: appListFetched } = AppListState
    const planSpecificaionState = useSelector(state => state.Home?.planSpecificationDetails?.plan)
    const { frstApiCl } = planSpecificaionState
    const navigate = useNavigate();
    const dummyData = [
        { 'title': 'Enroll API', 'subtitle': 'Stores new individuals’ facial data securely.', 'link': config.urls.apiDocEnrollUrl },
        { 'title': 'Verify API', 'subtitle': 'Confirms faces match stored data.', 'link': config.urls.apiDocVerifyUrl },
        { 'title': 'Recognize API', 'subtitle': 'Identifies faces from a large dataset accurately in real-time.', 'link': config.urls.apiDocRecognizeUrl, 'redirectNewPage': true }


    ]

    const handleCardClick = (ele) => {
        window.open(ele.link, '_blank', 'noopener noreferrer'); // Opens in a new tab

    }

    return (
        <div className="api-documents-description-container">
            {dummyData.map((ele, i) =>

                <div className="help-documents-field" key={i} onClick={() => handleCardClick(ele)}>

                    <div className="status-container">
                        <span className="title">{ele.title}</span>
                        {ele.fetchedStatus &&
                            <img className="status" src={ele.completed ? CompletedIcon : PendingIcon} />}
                    </div>
                    <span className="subtitle">{ele.subtitle}</span>

                </div>



            )}
        </div>
    )

}

const buttonDetails = [
    { 'buttonText': 'View all docs', buttonType: 'secondary', path: config.urls.apiDocUrl, redirectNewPage: true, }
]


const APIDocuments = () => {

    return (
        <React.Fragment>
            <CustomCard
                titleText={"API documents"}
                buttonsList={buttonDetails}>
                <APIDocumentsDescription />
            </CustomCard>
        </React.Fragment>
    );
};

export default APIDocuments;